import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Icon } from '@nobia/zeus-components/lib/icons'

const cogWheelSpin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const LoaderWrapper = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  line-height: 0;
  pointer-events: none;
  z-index: 2;
`

const SpinningCogWheel = styled(Icon).attrs({
  type: 'cog-wheel',
  width: 16,
  height: 16,
})`
  animation: ${cogWheelSpin} 1s linear infinite;
`

const CogWheelLoadingIcon = () => (
  <LoaderWrapper aria-hidden="true">
    <SpinningCogWheel />
  </LoaderWrapper>
)

export default CogWheelLoadingIcon
